import React from 'react';

function Categories() {
  return (
    <div>
      <h2>Categories Page</h2>

    </div>
  );
}

export default Categories;
